import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  href: "/frontend-dependencies.json",
  target: "_blank"
}
const _hoisted_2 = {
  href: "/backend-dependencies.txt",
  target: "_blank"
}
const _hoisted_3 = {
  href: "https://crowdin.com/project/diveni",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, { id: "about-page" }, {
    default: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_ctx.t("general.about.label")) + " Diveni", 1),
      _cache[0] || (_cache[0] = _createElementVNode("p", null, " WebApp to do Planning Poker with remote teams using external issue tracker as source of stories. ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "header" }, "Open Source & Contribution", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, [
        _createTextVNode(" Diveni is open source and published under "),
        _createElementVNode("a", {
          href: "https://github.com/Sybit-Education/Diveni/blob/main/LICENSE",
          target: "_blank"
        }, "GNU Affero General Public License v3.0"),
        _createTextVNode(". ")
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, [
        _createTextVNode(" Contributions are welcome on our public repository at "),
        _createElementVNode("a", {
          href: "https://github.com/Sybit-Education/Diveni",
          target: "_blank"
        }, "GitHub"),
        _createTextVNode(": ")
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "https://github.com/Sybit-Education/Diveni/",
            target: "_blank"
          }, "Code")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "https://github.com/Sybit-Education/Diveni/issues",
            target: "_blank"
          }, "Issues")
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: "https://github.com/Sybit-Education/Diveni/discussions",
            target: "_blank"
          }, "Discussions")
        ])
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "header" }, "Credits", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "header" }, "HTWG Konstanz", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", null, "TBD", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "header" }, "Sybit GmbH", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, " Sybit supports teaching at the university at HTWG Konstanz and acted as an industry partner in this project. A product owner represented Sybit's requirements to the students and released the sprints in the agile project development. ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, "Sybit GmbH will continue to support and maintain the project as an open source project.", -1)),
      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "header" }, "License", -1)),
      _cache[12] || (_cache[12] = _createElementVNode("p", null, [
        _createTextVNode(" Diveni is licensed under "),
        _createElementVNode("a", {
          href: "https://github.com/Sybit-Education/Diveni/blob/main/LICENSE",
          target: "_blank"
        }, "AGPL-3.0 license"),
        _createTextVNode(". ")
      ], -1)),
      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "header" }, "Used Libraries & Licenses", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.t("general.licenses.frontend")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t("general.licenses.backend")), 1)
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.t("general.licenses.translations")), 1)
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}